export * from './TabGroup';
//# sourceMappingURL=index.js.map